module.exports = __webpack_public_path__ + "img/banner.b763a0aa.png";